import { useCallback } from 'react'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'

import type { DialogProps } from '../types'

interface Props extends DialogProps {
  onSuccess: () => void
}

export const RunOMMWithdrawDialog = ({ isOpen, onClose, onSuccess }: Props) => {
  const onSubmit = useCallback(async () => {
    onSuccess()
    onClose()
  }, [onSuccess, onClose])

  return (
    <Dialog
      bigDialog
      childrenClassName="space-y-6"
      panelClassName="lg:max-w-[533px]"
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Are you sure?</Dialog.Title>
      </Dialog.Header>

      <p className="text-sm">
        This action cannot be undone and will withdraw the selected Online Mass
        Message for all recipients.
      </p>
      <p className="text-sm">
        Only messages sent within the last 24 hours can be withdrawn.
      </p>
      <p className="text-sm">
        Each OMM may include multiple messages, so the number shown may be
        higher than the number of OMMs sent.
      </p>

      <Dialog.ClosableFooter onClose={onClose}>
        <Button
          variant="destructive"
          onClick={onSubmit}
        >
          Confirm
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
